import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import ProjectContainer from "../containers/project";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";

const ProjectPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title="Latest Projects | Portfolio"
                    description="Read about the latest projects by Muhammad Sajid — web apps, AI models, and secure software. Browse the full project portfolio."
                    keywords="latest projects, read projects, portfolio project, web app, Muhammad Sajid, AI project"
                />
                <div className="main-wrapper">
                    <Header />
                    <ProjectContainer />
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default ProjectPage;
